//#region Util Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/load_indicator'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'

import { Enums } from '../../../models/common/enums'
import { IUserSession } from '../../../helpers/user-session'

import { OpHistory } from '../../../models/custom/op-history'

import { ColumnModel } from '../../api/api.models'
import { i18n } from '../i18n/common.i18n'
import { LogHelper, Dictionary, ConvertHelper, ToastHelper } from '../../../helpers'
import { GridOptions, GridTypes, GridController } from '../grid/grid.controller'
import { TableController } from '../common.table.controller'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { ConfigHelper } from '../../../helpers/config-helper'

import { IMRBaseControlDirectiveController } from '../base'

export interface HistorySource {
    id: number//DO USUNIECIA!!!
    dataMethodName: string//DO USUNIECIA!!!
    name: string//DO USUNIECIA!!!
    allowColumnReordering: boolean
    referenceType: Enums.ReferenceType
    referenceValue: number | number[],
    groupingColumn?: ColumnModel
    onRowDoubleClick?: (history: OpHistory) => void
    // onContentReady?: (e: any) => void
    onInitialized?: (component: IHistory) => void
}

export interface IHistory {
    refreshData: () => void
    getGrid(): GridController<any>
    isContentReady(isReady: boolean): void
}


interface HistoryScope extends ng.IScope {
    gridOptions: GridOptions
    source: any//DO USUNIECIA!!!
    showGrid: boolean
}

export class HistoryController extends IMRBaseControlDirectiveController implements IHistory {


    public static get LOG_PREFIX(): string { return '[SIMAX.History]' }
    private grid: GridController<any>

    constructor(private $scope: HistoryScope, private $q: ng.IQService, private $timeout: ng.ITimeoutService,
        private api: Api, private localDictionary: LocalDictionaryFactory,
        protected userSession: IUserSession) {
        super()

        var x = 0
        //TO DO!!! on refresh musi być podpinany do grida, i assync wywoływany ze srodka
        this.onRefresh()
    }

     private onRefresh(): void {
        if (this.$scope.source.data) {
            this.setOptions(this.$scope.source.data)
        } else if (_.isNumber(this.$scope.source.referenceValue)) {
            this.userSession.getDataProvider().System.getHistory(this.$scope.source.referenceValue, this.$scope.source.referenceType)
                .then((result: OpHistory[]) => {
                    this.setOptions(result)
                })
                .fail((error: any) => {
                    const msg: string = ConvertHelper.getRequestErrorMessage(error)
                    ToastHelper.showError(msg)
                    LogHelper.warn(HistoryController.LOG_PREFIX, `Unable to load history for ${Enums.ReferenceType[this.$scope.source.referenceType]} = ${this.$scope.source.referenceValue}`, error)
                    this.setOptions([], null)
                })
        } else if (_.isArray(this.$scope.source.referenceValue)) {
            this.getHistories()
                .then((histories: Dictionary<OpHistory[]>) => {
                    this.setOptions([], histories)
                })
                .fail((error: any) => {
                    this.setOptions([], null)
                    const msg: string = ConvertHelper.getRequestErrorMessage(error)
                    ToastHelper.showError(msg)
                })
        } else {
            this.setOptions([])
        }
    }

    onRowPrepared(e: any): void {
        if (e.rowElement.hasClass('dx-master-detail-row') && !e.data.longDescr)
            e.rowElement.addClass('display-none')

        //for showing tooltip
        if (e.rowType == 'detail') {
            if (_.size(e.rowElement) > 0) {
                const td: HTMLElement = e.rowElement[0].lastChild

                if (td != null) {
                    td.setAttribute('title', e.data.longDescr)
                }
            }
        }
    }
    onContentReady(e: any): void {
        this.$scope.showGrid = true

        this.isContentReady()
    }

     private setOptions(data: OpHistory[], historyDictionary?: Dictionary<OpHistory[]>) {

        const tempDataSource: OpHistory[] = []

        if (historyDictionary != null) {
            if (this.$scope.source.groupingColumn != null) {
                historyDictionary.forEach((key: number, value: OpHistory[]) => {
                    if (_.size(value) > 0) {
                        value.forEach((history: OpHistory) => {
                            history[this.$scope.source.groupingColumn.name] = key
                            tempDataSource.push(history)
                        })
                    }
                })
            }
        }

        const dataSource: OpHistory[] = historyDictionary != null ? tempDataSource : data
        const dateTimeColumn: DevExpress.ui.dxDataGridColumn = this.getDateTimeColumn()

        if (this.$scope.gridOptions) {
            this.grid.setDataSource(dataSource)
        } else {

            // for datetime only
            TableController.addCustomFiltersToDxColumn(dateTimeColumn, 'date', { type: Enums.DataTypeClass.Datetime }, false, null, null, null)

            this.$scope.gridOptions = {
                name: "History" + this.$scope.source.name,
                idReferenceType: Enums.ReferenceType.None,
                type: GridTypes.PAGINATED_SMALL,
                columns: this.getHistoryGridColumns(dateTimeColumn),
                dataSource: dataSource,
                masterDetail: {
                    enabled: false,
                    template: "detail",
                    autoExpandAll: true
                },
                onContentReady: (e) => { this.onContentReady(e) },
                onRowPrepared: (e) => { this.onRowPrepared(e) },
                onRowDoubleClick: (e) => this.onRowDoubleClick(e),
                onInitialized: (e: any, grid: GridController<any>) => {
                    this.grid = grid
                    if (this.$scope.source.onInitialized) {
                        this.$scope.source.onInitialized(this)
                    }
                },
                buttonsOptions: { enabled: true },
                searchVisibleColumnsOnly: false,
                addCustomFilters: true,
                allowColumnReordering: this.$scope.source.allowColumnReordering != null ? this.$scope.source.allowColumnReordering : true,
            }
        }
    }

    private getDateTimeColumn(): any {
        return {
            dataField: "eventDate",
            dataType: 'date',
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Date),
            customizeText: (options) => {
                return moment(options.value).format(ConfigHelper.getDateFormat(ConfigHelper.DateFormat.DATE_FORMAT_MOMENTJS))
            },
            editorOptions: TableController.getColumnEditorOptions('0', Enums.DataTypeClass.Datetime, this.$timeout),
            visible: true,
            columnType: Enums.DataTypeClass.Datetime
        }
    }

    private getHistories(): JQueryPromise<Dictionary<OpHistory[]>> {
        return this.userSession
            .getDataProvider()
            .System
            .getHistories(this.$scope.source.referenceValue, this.$scope.source.referenceType)
            .then((result: Dictionary<OpHistory[]>) => {
                return result
            })
            .fail((error: any) => {
                LogHelper.warn(HistoryController.LOG_PREFIX, `Unable to load history for ${Enums.ReferenceType[this.$scope.source.referenceType]} = ${this.$scope.source.referenceValue}`, error)
            })
    }
    private getHistoryGridColumns(dateTimeColumn: any): DevExpress.ui.dxDataGridColumn[] {
        const columns: DevExpress.ui.dxDataGridColumn[] = [
            dateTimeColumn,
            { dataField: "eventType", dataType: 'string', caption: i18n("Common", "EventType"), visible: true },
            { dataField: "descr", dataType: 'string', caption: i18n("Common", "Description"), visible: true },
            { dataField: "longDescr", dataType: 'string', caption: i18n("Common", "Description"), visible: false }
        ]
        if (this.$scope.source.groupingColumn) {
            columns.push({
                dataField: this.$scope.source.groupingColumn.name,
                dataType: 'string',
                caption: this.$scope.source.groupingColumn.caption,
                visible: true,
                allowGrouping: true,
                groupIndex: 0,
                width: 100,
            })
        }

        return columns
    }

    private onRowDoubleClick(row: any): void {
        if (_.isFunction(this.$scope.source.onRowDoubleClick)) {
            this.$scope.source.onRowDoubleClick(row.data)
        }
    }

    // #region IHistroy Implementation

    public refreshData(): void {
        this.onRefresh()
    }

    public isContentReady(): void {
    }

    public getGrid(): GridController<any> {
        return this.grid
    }

    // #endregion 
}
